import { FC, useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useTranslation } from 'react-i18next';
import Form from 'components/form/Form';
import FormGroup from 'components/form/FormGroup';

interface IProps {
  methods: any;
  data: any;
  onSubmit: (data: any) => void;
  reportParams?: any;
}
interface IDataType {
  [key: string]: string | number | boolean;
}

const ReportForm: FC<IProps> = ({ methods, data, onSubmit }) => {
  const { t } = useTranslation();
  const [employees, setEmployees] = useState(data?.user || []);

  useEffect(() => {
    methods.setValue(
      'status',
      data?.status.filter((j: IDataType) => j.selected)
    );

    // Set default period to current month/year
    const today = new Date();
    methods.setValue('period', today);
  }, []);

  const groups = methods.watch('group');

  useEffect(() => {
    const groupIds = groups?.map((gr: any) => gr.value);

    /**
     * When a group is selected, filter employee options
     * to only employees from groups selected and
     * automatically select all employees
     *
     * If no group selected - clear selected employees
     */
    if (groupIds) {
      const filteredEmployees = data?.user.filter((empl: any) => {
        /**
         * If employee doesn't have any groups check if "No group"
         * is selected which value is set to 0 from BE
         */
        if (!empl.groups.length) return groupIds.includes('null');

        const isInSelectedGroups = empl.groups.reduce((flag: boolean, currGr: number) => {
          return flag || groupIds.includes(currGr);
        }, false);
        return isInSelectedGroups;
      });

      setEmployees(filteredEmployees);
      methods.setValue('user', filteredEmployees);
    } else {
      setEmployees(data?.user);
      methods.setValue('user', null);
    }
  }, [groups]);

  return (
    <Form
      methods={methods}
      btnLabel={t('reports.downloadLeavesReport')}
      hideCancelBtn
      onSubmit={onSubmit}
    >
      <Row>
        <Col
          md={{
            offset: 2,
            span: 4,
          }}
        >
          <FormGroup
            controlId="formGroupFromDate"
            label={t('table.leavePeriod')}
            type="datepicker"
            name="period"
            dateFormat="MM.yyyy"
            showMonthDropdown
            showYearDropdown
            showMonthYearPicker
            isRequired
          />
        </Col>
        <Col md={4}>
          <FormGroup
            controlId="formGroupStatus"
            label={t('table.statusFilter')}
            type="select"
            as="select"
            name="status"
            isMulti
            isClearable
            isSearchable
            allowSelectAll
            selectOptions={data?.status}
          />
        </Col>
      </Row>
      <Row>
        <Col
          md={{
            offset: 2,
            span: 4,
          }}
        >
          <FormGroup
            controlId="formGroupEmployees"
            label={t('reports.employees')}
            type="select"
            as="select"
            name="user"
            isMulti
            isClearable
            isSearchable
            allowSelectAll
            showTotal
            limitOptions
            selectOptions={employees}
          />
        </Col>
        <Col md={4}>
          <FormGroup
            controlId="formGroupGroups"
            label={t('reports.groups')}
            type="select"
            as="select"
            name="group"
            isMulti
            isClearable
            isSearchable
            allowSelectAll
            selectOptions={data?.group}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default ReportForm;
